//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CoinHeader from '~/components/detail/desktop/coin_header'
import ChartConverter from '~/components/detail/desktop/chart_converter'
import CoinWeblog from '~/components/detail/desktop/coin_weblog'
import CoinDetail from '~/components/detail/desktop/coin_detail'
import CoinsPopular from '~/components/detail/desktop/coins_popular'
import CoinsNew from '~/components/detail/desktop/coins_new'
import Convertor from '~/components/detail/desktop/convertor'
export default {
  name: 'Desktop',
  components: {
    CoinHeader,
    ChartConverter,
    CoinWeblog,
    CoinDetail,
    CoinsPopular,
    CoinsNew,
    Convertor
  },
  props: {
    coin: {
      type: Object,
      default: null
    }
  }
}
